import { render, staticRenderFns } from "./BankLink.vue?vue&type=template&id=664e66b0&scoped=true&"
import script from "./BankLink.vue?vue&type=script&lang=ts&"
export * from "./BankLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e66b0",
  null
  
)

export default component.exports